// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__38Kz9","overflowing":"ReadFullNote_overflowing__1m8gx"};